var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Center, FormControl, FormErrorMessage, FormLabel, Input, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import React from 'react';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { emailStringVerify } from '@@/Util';
import { observer } from 'mobx-react';
import { AddNewConnectResponseStatus } from '@/share/models';
import { Apphandler } from '@/ipc/MainAppHandler';
import { APPEvent } from '@/events/AppEvents';
import { ScaleLoader } from 'react-spinners';
export class NewConnectDialogState {
    constructor() {
        this.open = false;
        this.email = "";
        this.emailerror = "";
        this.enableInvite = false;
        this.sending = false;
        this.sendingresult = "";
        this.sendingresultcolro = "green";
        this.baseDialogState = new BaseDialogState();
        makeObservable(this);
        this.baseDialogState.setDisableOkButton(!this.enableInvite);
        this.baseDialogState.setHeaderLabel("Add New Connect");
        this.baseDialogState.setOkLabel("Add");
        this.baseDialogState.setDisableOkButton(!this.enableInvite);
        this.baseDialogState.onOk = () => this.sendInvite();
        APPEvent.addSubscriberForAddConnect((c) => {
            if (c.email === this.email) {
                if (c.res === AddNewConnectResponseStatus.Added) {
                    this.setOpen(false);
                    this.setEmail("");
                }
                else if (c.res === AddNewConnectResponseStatus.ConnectLetrwingUser) {
                    this.setEmailError("User already part of Letrwing family. Perhaps try adding them as external contact.");
                }
                else if (c.res === AddNewConnectResponseStatus.Failed) {
                    this.setEmailError("So sorry but failed to connect. Please try again later.");
                }
                this.setSending(false);
                this.baseDialogState.setDisableCancelButton(false);
                this.baseDialogState.setDisableOkButton(false);
            }
        });
    }
    sendingResult(result) {
        this.sendingresult = result;
    }
    setSendingResultColor(color) {
        this.sendingresultcolro = color;
    }
    sendInvite() {
        if (!this.email || !emailStringVerify(this.email)) {
            this.setEmailError("Please enter valid email");
            return;
        }
        this.baseDialogState.setDisableOkButton(true);
        this.baseDialogState.setDisableCancelButton(true);
        // we should send invite here and we good to go now!
        this.setSending(true);
        this.createNewConnect(this.email);
    }
    createNewConnect(email) {
        const req = { email: email };
        Apphandler.sendMessage("addconnects", req);
    }
    setSending(sending) {
        this.sending = sending;
    }
    setEmailError(err) {
        this.emailerror = err;
    }
    setOpen(open) {
        this.open = open;
        this.baseDialogState.setOpen(open);
    }
    setEmail(email) {
        this.email = email;
        if (emailStringVerify(this.email)) {
            this.enableInvite = true;
            this.baseDialogState.setDisableOkButton(false);
        }
        else {
            this.enableInvite = false;
            this.baseDialogState.setDisableOkButton(true);
        }
    }
    reset() {
        this.setSending(false);
        this.setEmail("");
        this.setEmailError("");
        this.sendingResult("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], NewConnectDialogState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewConnectDialogState.prototype, "email", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewConnectDialogState.prototype, "emailerror", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewConnectDialogState.prototype, "enableInvite", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewConnectDialogState.prototype, "sending", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewConnectDialogState.prototype, "sendingresult", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NewConnectDialogState.prototype, "sendingresultcolro", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewConnectDialogState.prototype, "sendingResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewConnectDialogState.prototype, "setSendingResultColor", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewConnectDialogState.prototype, "setSending", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewConnectDialogState.prototype, "setEmailError", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], NewConnectDialogState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], NewConnectDialogState.prototype, "setEmail", null);
let NewConnectDialog = class NewConnectDialog extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.state.reset();
    }
    buildDialogBody() {
        return React.createElement(Box, null,
            React.createElement(FormControl, { id: "email" },
                React.createElement(FormLabel, null, "Email address"),
                React.createElement(Input, { value: this.props.state.email, onChange: (e) => this.props.state.setEmail(e.target.value), type: "email" }),
                React.createElement(FormErrorMessage, null, this.props.state.emailerror)),
            React.createElement(Box, { h: '40px', mt: '10px' },
                this.props.state.sending && React.createElement(Center, { w: '100%' },
                    React.createElement(ScaleLoader, { color: 'green' })),
                React.createElement(Text, { color: this.props.state.sendingresultcolro, fontSize: '21px' }, this.props.state.sendingresult)));
    }
    render() {
        return (React.createElement(Box, null,
            React.createElement(BaseDialog, { state: this.props.state.baseDialogState, body: this.buildDialogBody() })));
    }
};
NewConnectDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], NewConnectDialog);
export { NewConnectDialog };
